import { Modal } from '@collaborator/npm_modules/dist/components/modal';
import app from 'srcJs/App';
import { Form } from 'react-final-form';
import { Input } from 'components/form/fields/Input';
import { Button } from 'components/button/Button';
import * as React from 'react';
import { useRef } from 'react';
import { useHistoryPush } from 'components/history/use-history-push';
import { useUserData } from 'components/user/hooks/use-user-data';

var CreateProjectModal = function CreateProjectModal(_ref) {
  var isVisibleCreateProjectModal = _ref.isVisibleCreateProjectModal,
      createProjectModalHide = _ref.createProjectModalHide;
  var userData = useUserData();
  var refInput = useRef();
  var historyPush = useHistoryPush();

  if (userData.hasProjects) {
    return null;
  }

  var handlerEntering = function handlerEntering() {
    refInput.current.focus();
  };

  var handlerSubmit = function handlerSubmit(values) {
    if (!values.name) {
      return {
        name: app.tForReact('cart_notifier', 'Indicate the name of the project')
      };
    }

    createProjectModalHide();
    historyPush({
      pathname: '/project/create',
      search: "name=".concat(values.name)
    });
    return null;
  };

  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisibleCreateProjectModal,
    onHide: createProjectModalHide,
    onEntering: handlerEntering
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    onHide: createProjectModalHide
  }, app.tForReact('cart_notifier', 'Create a project')), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handlerSubmit,
    render: function render(form) {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: form.handleSubmit
      }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("p", {
        className: "fs-12 color-858585"
      }, app.tForReact('cart_notifier', 'In order to post a publication you first need to create a project. Enter the name of the project:')), /*#__PURE__*/React.createElement(Input, {
        name: "name",
        ref: refInput,
        placeholder: app.tForReact('cart_notifier', 'Project name'),
        formGroupProps: {
          className: 'mb-0 form-group'
        }
      })), /*#__PURE__*/React.createElement(Modal.Footer, {
        className: "d-flex justify-content-end gap-15px"
      }, /*#__PURE__*/React.createElement(Button, {
        secondary: true,
        additionalClassName: "flex-grow-1 flex-lg-grow-0",
        onClick: createProjectModalHide
      }, app.tForReact('cart_notifier', 'Cancel')), /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        primary: true,
        additionalClassName: "flex-grow-1 flex-lg-grow-0",
        prettyLoaderProps: {
          isLoading: form.submitting
        }
      }, app.tForReact('cart_notifier', 'Add project'))));
    }
  }));
};

export { CreateProjectModal };